import { store } from '/@/store'

/**
 * @file src/store/modules/updateScreen.ts
 * @description This module manages the visibility of the update screen in the application.
 * It provides a store to show or hide the update screen based on user actions.
 *
 */
export const useUpdateScreenStore = defineStore('updateScreen', () => {
  /**
   * @name isUpdateScreenVisible
   * @description Reactive state to track the visibility of the update screen.
   * @type {Ref<boolean>}
   * @default false
   */
  const isUpdateScreenVisible: Ref<boolean> = ref(false)

  /**
   * @function showUpdateScreen
   * @description Function to set the update screen visibility to true.
   * This function can be called to display the update screen when an update is available.
   */
  function showUpdateScreen() {
    isUpdateScreenVisible.value = true
  }

  /**
   * @function hideUpdateScreen
   * @description Function to set the update screen visibility to false.
   * This function can be called to hide the update screen after the user has acknowledged the update.
   */
  function hideUpdateScreen() {
    isUpdateScreenVisible.value = false
  }

  return {
    isUpdateScreenVisible,
    showUpdateScreen,
    hideUpdateScreen,
  }
})

// Need to be used outside the setup
export function useUpdateScreenStoreWithout() {
  return useUpdateScreenStore(store)
}
